export const conceptsNames: any = [
    'Proyecto Básico (P.B.)',
    'Proyecto de Ejecución (P.E.)',
    'Estudio Básico de Seguridad y Salud (E.B.S.S.)',
    'Dirección de Obra y Dirección de Ejecución de Obra (D.O. + D.E.O.)',
    'Coordinación de Seguridad y Salud (C.S.S.)',
    'Tasas e impuestos municipales',
    'Otros'
];